/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { dependencyAnalysisSchema } from './dependencyAnalysisSchema';
import { impactCountsSchema } from './impactCountsSchema';
import { impactHeadlineSchema } from './impactHeadlineSchema';
import { itemImpactEntrySchema } from './itemImpactEntrySchema';
import { riskAnalysisSchema } from './riskAnalysisSchema';
import { teamLoadShiftEntrySchema } from './teamLoadShiftEntrySchema';
import { teamMoveGroupEntrySchema } from './teamMoveGroupEntrySchema';

export const scenarioImpactSummarySchema = z.object({
  get counts() {
    return impactCountsSchema;
  },
  get dependencies() {
    return dependencyAnalysisSchema;
  },
  get headline() {
    return impactHeadlineSchema;
  },
  get itemChanges() {
    return z.array(itemImpactEntrySchema);
  },
  loopId: z.int(),
  portfolioSyncAlerts: z.array(
    z.enum([
      'SCENARIO_ITEM_MODIFIED',
      'ITEM_STORE_SCHEDULE_CHANGES',
      'ITEM_STORE_DEPENDENCY_CHANGES',
      'ITEM_STORE_ITEMS_ADDED',
      'ITEM_STORE_ITEMS_DELETED',
      'TEAM_COMPOSITION_UPDATED',
      'ESTIMATION_EFFORT_UPDATED',
      'ITEMS_UNDER_DONE_ANCESTOR',
      'TEAM_WITHOUT_MEMBERS',
      'PENDING_RESCHEDULE',
    ]),
  ),
  get risk() {
    return riskAnalysisSchema;
  },
  scenarioId: z.int(),
  scenarioName: z.string(),
  get teamLoadShift() {
    return z.array(teamLoadShiftEntrySchema);
  },
  get teamMoveGroups() {
    return z.array(teamMoveGroupEntrySchema);
  },
  totalItemsChanged: z.int(),
  truncated: z.boolean(),
});
